import React, { useState } from 'react'
import I18n from 'i18n'
import ComplianceChart from './ComplianceChart'
import { useResearchDashboardMetricsQuery } from '../../../../backend/Queries'

export default function QuestionnaireComplianceChart (): React.ReactElement {
  const [offset, setOffset] = useState(0)
  const { data, isLoading } = useResearchDashboardMetricsQuery('monthly', offset)

  return (
    <ComplianceChart
      title={I18n.t('components.dashboards.research_dashboard.charts.compliance_questionnaires')}
      data={data?.questionnaires}
      color='#d32f2f'
      isLoading={isLoading}
      offset={offset}
      onOffsetChange={setOffset}
      currentWeekLabel={offset === 0 ? data?.questionnaires?.history?.[data.questionnaires.history.length - 1]?.label : undefined}
    />
  )
}
